import { reactive, readonly } from 'vue'

interface Toast {
  message: string
  type: string
  id: number
}

const state = reactive<{
  toasts: Toast[]
}>({
  toasts: [],
})

function _toast(message: string, type: string = 'success', timeout: number = 3000): void {
  const id = Date.now()
  state.toasts.push({ message, type, id })
  setTimeout(() => {
    const index = state.toasts.findIndex((t) => t.id === id)
    state.toasts.splice(index, 1)
  }, timeout)
}

function success(message: string, timeout: number = 3000): void {
  _toast(message, 'success', timeout)
}

function error(message: string, timeout: number = 3000): void {
  _toast(message, 'error', timeout)
}

export const useToast = readonly({
  success,
  error,
  state: readonly(state),
  close,
})
